import { checkReport, cancelCollect } from "@/request/api";
import { message } from "antd";
import moment from "moment";

export const initCheckReport = (CONCLUSIONS, id, status, callBack) => {
	// 开始报告更新审核状态
	console.log("调用这个方法");
	const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
	var dateTime = moment().format("YYYY-MM-DD HH:mm:ss");
	let params = {
		EXAM_UID: id, // 检查唯一uid
		EXAM_STATUS: status, // 检查状态  3审核 2报告
		CONCLUSIONS: CONCLUSIONS, // 检查结论
	};

	let type;
	if (status === 3) {
		params.CHECK_DOCTOR_CODE = userInfo.USER_UID; // 审核人唯一uid
		params.CHECK_DOCTOR_NAME = userInfo.REAL_NAME; // 审核人
		params.CHECK_DATETIME = dateTime; //审核时间
		type = "CheckReport";
	} else {
		params.REPORT_DOCTOR_UID = userInfo.USER_UID; // 报告人唯一ID
		params.REPORT_DOCTOR_NAME = userInfo.REAL_NAME; // 报告人
		params.REPORT_DATETIME = dateTime; //报告时间
		type = "Report";
	}
	console.log(params);
	checkReport(type, params).then((res) => {
		if (res && res.Status === 1) {
			if (callBack) {
				callBack();
			}
		} else {
			message.error("信息编辑失败！");
		}
	});
};

// 获取当前患者最新数据
export const getCancelCollect = (id) => {
	let params1 = {
		Type: "GetConsultationList",
		EXAM_UID: id,
	};
	return cancelCollect(params1);
}
